import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { tap, Observable } from 'rxjs';

import { AuthUser } from '@shared/signup/models';
import { UserLocationRole } from '@shared/user/enums';
import { ConfirmationModalRef, ConfirmationModalService } from '@tablesready/common-ui';

@Injectable({ providedIn: 'root' })
export class PricePlansRestrictionsModalService {
  constructor(
    private readonly router: Router,
    private readonly confirmationModalService: ConfirmationModalService,
  ) {}

  display(user: AuthUser, starterPlanFeature = false): Observable<ConfirmationModalRef<boolean>> {
    const title = starterPlanFeature ? 'Starter Plan Feature' : 'Business Plan Feature';
    const isUser = user.locationUser.role === UserLocationRole.user;
    const options = isUser
      ? {
        title,
        content: 'Ask your location manager to upgrade your plan today',
        confirmBtnText: 'Confirm',
        backdropDismiss: false,
      } : {
        title,
        content: 'Upgrade your plan to unlock this feature today!',
        confirmBtnText: 'Upgrade your plan',
        closeBtnText: 'Cancel',
        backdropDismiss: false,
      };

    return this.confirmationModalService.confirm(options)
      .pipe(
        tap(({ isConfirmed }) => {
          if (isConfirmed && !isUser) {
            void this.router.navigateByUrl('/settings/location/billing');
          }
        }),
      );
  }
}
